<template>
  <div class="option-item--user">
    <thumbnail :src="thumbnail" size="32px" :username="name" />
    <div class="option__user-data">
      <div class="option__name-row">
        <span class="option__name">{{ name }}</span>
        <template v-if="identifier">
          <span class="option__dot" />
          <span class="option__id">#{{ identifier }}</span>
        </template>
      </div>
      <div v-if="email" class="option__body">
        <span class="email-icon-wrap">
          <fluent-icon class="merge-contact--icon" icon="mail" size="12" />
          <span class="truncate">{{ email }}</span>
        </span>
      </div>
      <div v-if="phoneNumber && !hidePhone" class="option__body">
        <span class="phone-icon-wrap">
          <fluent-icon class="merge-contact--icon" icon="call" size="12" />
          {{ phoneNumber }}
        </span>
      </div>
      <div v-if="!phoneNumber && !email" class="option__body">
        <span>{{ '---' }}</span>
      </div>
      <div v-if="companyName && !hideCompany" class="option__footer">
        <span class="company-icon-wrap">
          <fluent-icon
            class="merge-contact--icon"
            icon="building-bank"
            size="12"
          />
          {{ companyName }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Thumbnail from '../../../components/widgets/Thumbnail.vue';

export default {
  components: {
    Thumbnail,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    thumbnail: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    identifier: {
      type: [String, Number],
      required: true,
    },
    companyName: {
      type: String,
      default: '',
    },
    hidePhone: {
      type: Boolean,
      default: false,
    },
    hideCompany: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.option-item--user {
  @apply flex items-center gap-3;
}

.option__user-data {
  @apply flex flex-col flex-grow gap-1 min-w-0;
}

.option__name-row {
  @apply flex items-center gap-2;
}

.option__name {
  @apply text-sm font-semibold text-[#323431] whitespace-nowrap;
}

.option__dot {
  @apply w-1 h-1 rounded-full bg-[#d9d9d9] shrink-0;
}

.option__id {
  @apply text-xs text-gray-500 whitespace-nowrap;
}

.option__body,
.option__footer {
  @apply flex items-center gap-1 text-xs text-gray-500;
}

.option__user-data .option__body {
  > .phone-icon-wrap,
  > .company-icon-wrap,
  > .email-icon-wrap {
    @apply flex items-center gap-1 min-w-0;
  }
}

.merge-contact--icon {
  @apply shrink-0;
}
</style>
